<div class="container">
  <mic-breadcrumb id="adjustment-reasons-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('adjustmentReasonText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="adjustment-reasons-header">
    <h2 class="page-title adjustment-reasons-heading" id="adjustment-reasons-heading">
      {{ translationService.translate('adjustmentReasonText') }}
    </h2>
    <div class="action-bar">
      <button
        id="reset-filters"
        type="button"
        mat-flat-button
        color="accent"
        class="btn-clear adjustment-action-button"
        (click)="clearFilters()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>
      <button mat-flat-button color="primary" class="btn-export adjustment-action-button" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="adjustment-filter-card">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          id="adjReason"
          formControlName="adjReason"
          [data]="reasonsList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('adjustmentReasonText') }}"
          label="{{ translationService.translate('adjustmentReasonText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="description"
          formControlName="description"
          [data]="descriptionsList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('descriptionText') }}"
          label="{{ translationService.translate('descriptionText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="type"
          formControlName="type"
          [data]="typesList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('typeColumnText') }}"
          label="{{ translationService.translate('typeColumnText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="adjustable"
          formControlName="adjustable"
          [data]="adjustableList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('adjustableText') }}"
          label="{{ translationService.translate('adjustableText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>

        <mic-dropdown-search
          micDropdownAccessibility
          id="active"
          formControlName="active"
          [data]="activeList"
          [widthConfig]="{ width: '100%' }"
          placeholder="{{ translationService.translate('activeText') }}"
          label="{{ translationService.translate('activeText') }}"
          searchPlaceholder="Search"
          subscriptSizing="dynamic"
          [multiple]="true"
        ></mic-dropdown-search>
      </div>
    </form>
  </mat-card>

  <div id="adjustment-reasons-table" class="cam-table table-container btn-table">
    <div class="table-wrapper">
      <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'activeCell'">
          <div class="flex flex-row gap-2">
            @if (item.active === 'Y' || item.active === '1') {
            <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
            }@else {
            <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
            }
          </div>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
            <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
          </button>
          <mat-menu #colMenu="matMenu">
            <div class="column-menu-content">
              @for (key of columnKeys; track key) {
              <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">{{
                columnNames[key] || key
              }}</mat-checkbox>
              }
            </div>
          </mat-menu>
        </ng-container>
      </mic-table>
    </div>
  </div>
</div>
